import React from 'react';
import './DataTables.css';
import { translations } from '../translations';

const DataTables = ({ frequencies, language }) => {
  const t = translations[language];
  const totalFreq = Object.values(frequencies).reduce((sum, freq) => sum + freq, 0);

  return (
    <div className="data-tables">
      <div className="table-container">
        <h3>{t.dataTableTitle}</h3>
        <div className="data-table">
          {/* Sum row */}
          <div className="header">{t.total}</div>
          {Array.from({ length: 9 }, (_, i) => i + 2).map(sum => (
            <div key={sum} className="cell">
              {sum}
            </div>
          ))}
          <div className="cell total">{t.total}</div>
          
          {/* Frequency row */}
          <div className="header">{t.frequency}</div>
          {Array.from({ length: 9 }, (_, i) => i + 2).map(sum => {
            const freq = frequencies[sum] || 0;
            const cellClass = sum === 9 || sum === 10 ? 'cell highlight' : 'cell';
            return (
              <div key={`freq-${sum}`} className={cellClass}>
                {freq}
              </div>
            );
          })}
          <div className="cell total">{totalFreq}</div>
        </div>
      </div>
    </div>
  );
};

export default DataTables; 